import BluebirdPromise from 'bluebird';
import { navigationState } from 'app/src/components/Header/navigationState';

export const getSpinner = () => {
  navigationState.setValue({
    isNavigating: true,
  });

  return BluebirdPromise.resolve().disposer(function () {
    navigationState.setValue({
      isNavigating: false,
    });
  });
};
